export class CacheKey {
    public static UserId: string = "userId";
    public static UserName: string = "user_name";
    public static FirstName: string = "first_name";
    public static LastName: string = "lastName";
    public static CountryName: string = "countryName";
    public static AccessToken: string = "access_token";
    public static RefreshToken: string = "refresh_token";
    public static Language: string = "language";
    public static DefaultLanguage: string = "DefaultLanguage";
    public static Nav_path: string = "Nav_path";
    public static Configuration: string = "Configuration";
    public static StoreId: string = "storeid";
    public static Store: string = "Store";
    public static UserPermissions: string = "UserPermissions";
    public static RoleSearch: string = "RoleSearch";
    public static UserSearch: string = "UserSearch";
    public static StoreUserSearch: string = "StoreUserSearch";
    public static UserInfo: string = "UserInfo";
    public static ModuleId: string = "moduleId";
    public static Id_Nonce: string = "id_nonce";
    public static State: string = "state";
    public static BusinessEntitySearch: any = "BusinessEntitySearch";
    public static PricetierSearch: any = "PricetierSearch";
    public static MemberPricetierSearch: any = "MemberPricetierSearch";
    public static CountriesSearch: string = "CountriesSearch";
    public static CurrenciesSearch: string = "CurrenciesSearch";
    public static LanguagesSearch: string = "LanguagesSearch";
    public static MenuSearch: string = "MenuSearch";
    public static PaymentMethodSearch: string = "PaymentMethodSearch";
    public static PaymentProcessorSearch: string = "PaymentProcessorSearch";
    public static ProductSearch: string = "ProductSearch";
    public static DocumentLibrary: string = "DocumentLibrarySearch";
    public static SideMenuPosition: string = "SideMenuPosition";
    public static EventSearch: string = "EventSearch";
    public static PaymentInstrumentId = 'PaymentInstrumentId';
    public static SessionGuid = 'SessionGuid';
    public static EPSS = 'EPSS';
    public static TITAN = "TITAN";
    public static AS400 = 'AS400';
    public static InternalMemberSessionGuid = 'InternalMemberSessionGuid';
    public static ExternalMemberSessionGuid = 'MemberSessionGuid';
    public static language = 'language';
    public static RebindSponsor='RebindSponsor';
    public static ORDER_INFO_SESSION_CODE = 'orderInfoTabInfo';
    public static FboProfileDetail = 'FboProfileDetail';
    public static DistributorInfo = 'DistributorInfo';
    public static IsRefreshed = "IsRefreshed";
    public static OrderInfo = 'OrderInfo';
    public static IsDistributeTicket = 'IsDistributeTicket';
    public static CREATE_ORDER_INFO_SESSION_CODE = 'CreateOrderInfo';
    public static CREATE_POS_ORDER_INFO_SESSION_CODE = 'CreatePOSOrderInfo';
    public static CREATE_SERVICE_ORDER_INFO_SESSION_CODE = 'CreateServiceOrderInfo';
    public static COUNTRIES = 'Countries';
    public static CARTUPDATED = 'cartUpdated';
    public static ORDERTABREFRESH = 'orderTabRefresh';
    public static FORM_TICKETS_SEARCH = 'formTicketSearch';
    public static COUNTRY_ID = 'countryId';
    public static COUNTRY_CODE = 'countryCode';
    public static LANGUAGE_CODE = 'languageCode';
    public static IsServiceOrder = 'IsServiceOrder';
    public static PaymentStatus = 'PaymentStatus';
    public static pollCount = 'pollCount';
    public static guestToken = 'guestToken';
    public static isGuestToken = 'isGuestToken';
    public static TBEToken = 'TBEToken';
    public static DepositFeeProductsInfo = 'DepositFeeProductsInfo';
    public static ProductAssociationInfo = 'ProductAssociationInfo';
    public static CDNurlForProfileImage = 'cdnUrlForProfileImage';
    public static SelectedPOSLocation = 'SelectedPOSLocation';
    public static SelectedTerminalDetails = 'SelectedTerminalDetails';
    public static Cities = 'cities';
    public static StatesByCountryId = 'StatesByCountryId';
    public static RegularFlow = 'RegularFlow';
    public static posOrderPaymentStatus = 'posOrderPaymentStatus';
    public static RetirementModal = 'retirementModal';
    // public static UserDetails = 'userDetails';
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/cachekey.constants.ts